import React, { lazy, Suspense, useContext } from "react";
import { createBrowserRouter, Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Loading from "../components/loading/loading"
import Layout from "../layout/index";
const Login = lazy(() => import("../pages/login/login"));
const Home = lazy(() => import("../pages/home"));
const Profile = lazy(() => import("../pages/profile"));
const Admins = lazy(() => import("../pages/admins"));
const UserCreate = lazy(() => import("../pages/admins/userCreate/usercreate"));
const UserEdit = lazy(() => import("../pages/admins/userEdit/edit"));
const Orders = lazy(() => import("../pages/Orders/index"));
const AllOrders = lazy(() => import("../pages/Orders/Services/AllOrders"));
// const TypeofServices = lazy(() => import("../pages/Orders/Services/TypeofService/index"));
const Form = lazy(() => import("../pages/Orders/Services/Form/index"));
const Specialist = lazy(() => import("../pages/Orders/Services/Specialists"));
const SpecialistDetails = lazy(() => import("../pages/Orders/Services/Specialists/SpecialistDetails"));
const CompletedAppointment = lazy(() => import("../pages/Orders/Services/CompletedAppointment"));
const Bildiriş = lazy(() => import("../pages/notification/index"));
const İcazələr = lazy(() => import("../pages/permissions"));
const İcazələrr = lazy(() => import("../pages/permissions/permissionsedit"));
const YeniVezifeler = lazy(() => import("../pages/permissions/newpermissions"));
const DestekKomandası = lazy(() => import("../pages/supportteam"));
const DestekKomandasıProfil = lazy(() => import("../pages/supportteam/supportProfile"));
const Statistics = lazy(() => import("../pages/statistics"));
const Activities = lazy(() => import("../pages/activities/activities"));
const StatisticsTables = lazy(() => import("../pages/statistics/statisticstables"));
// const CvBazasi = lazy(() => import("../pages/cv-bazasi"));
// const CvCreate = lazy(() => import("../pages/cv-bazasi/create"));
const Customers = lazy(() => import("../pages/customers"));
const CustomerForm = lazy(() => import("../pages/customers/form"));
const CustomerDetail = lazy(() => import("../pages/customers/detail"));

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);

  if (loading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/loginform" replace />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);

  if (loading) {
    return <Loading />;
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export const router = createBrowserRouter([
  {
    path: "/loginform",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/admins",
        element: <Admins />,
      },
      {
        path: "/musteriler",
        element: <Customers />,
      },
      {
        path: "/musteriler/create",
        element: <CustomerForm />,
      },
      {
        path: "/musteriler/edit/:id",
        element: <CustomerForm />,
      },
      {
        path: "/musteriler/:id",
        element: <CustomerDetail />,
      },
      {
        path: "/usercreate",
        element: <UserCreate />,
      },
      {
        path: "/useredit/:id",
        element: <UserEdit />,
      },
      {
        path: "/orders",
        element: <Orders />,
      },
      {
        path: "/allorders",
        element: <AllOrders />,
      },
      // {
      //   path: "/typeofservices",
      //   element: <TypeofServices />,
      // },
      {
        path: "/orderform",
        element: <Form />,
      },
      {
        path: "/notification",
        element: <Bildiriş />,
      },
      {
        path: "/permissions/",
        element: <İcazələr />,
      },
      {
        path: "/permissionsedit/:id",
        element: <İcazələrr />,
      },
      {
        path: "/newpermissions",
        element: <YeniVezifeler />,
      },
      {
        path: "/supportteam/",
        element: <DestekKomandası />,
      },
      {
        path: "/supportprofile/:id",
        element: <DestekKomandasıProfil />,
      },
      {
        path: "/statistics",
        element: <Statistics />,
      },
      {
        path: "/activities",
        element: <Activities />,
      },
      // {
      //   path: "/cv-bazasi",
      //   element: <CvBazasi />,
      // },
      // {
      //   path: "/cv-bazasi/:id",
      //   element: <CvBazasi />,
      // },
      // {
      //   path: "/cv-bazasi/create",
      //   element: <CvCreate />,
      // },
      {
        path: "/statisticstables",
        element: <StatisticsTables />,
      },
      {
        path: "/specialists",
        element: <Specialist />,
      },
      {
        path: "/specialistsdetails/:id",
        element: <SpecialistDetails />,
      },
      {
        path: "/completedappointment",
        element: <CompletedAppointment />,
      },
    ],
  },
]);
